import React, { useState } from 'react'
import { sanitizeHTML, APIENDPOINT, getCWPEnvironmentForURL } from '../../../../utils/common-utils'
import { CardPersonProps } from './CardPerson.type'

export const CardPerson = (props: CardPersonProps) => {
  const { componentSpacing, cardLimit, cardList, cardPersonHeadline, brandExtension } = props

  if (!cardList) {
    return null
  }

  const numberOfCardsToShow = cardLimit ? Number(cardLimit) : cardList?.length

  const [showLoadMore, setShowLoadMore] = useState(
    numberOfCardsToShow && cardList && numberOfCardsToShow < cardList?.length
  )

  return (
    <section
      className={`card-grid-component card-person ${componentSpacing} ${brandExtension}`}
      data-limit={cardLimit}
    >
      <div
        className='u-sizeConstrained u-sm-flexCol u-sm-flexJustifyCenter'
        data-testid={props.testId ?? null}
      >
        <div className='u-flex u-flexJustifyBetween'>
          {cardPersonHeadline && (
            <h2 className='u-textColorDefault u-marginBottom24'>{cardPersonHeadline}</h2>
          )}
        </div>
        <div className='card-list-wrapper u-sm-flex u-sm-flexCol u-marginBottom20'>
          {cardList.slice(0, showLoadMore ? numberOfCardsToShow : cardList.length).map(card => {
            const cardImagePath = card.cardContent?.cardImage
              ? card.cardContent.cardImage
              : `${
                  APIENDPOINT(getCWPEnvironmentForURL(window.location.toString())).baseGallery
                }/content/gallery/ampmicrosites/card-default-image.png`
            const backgroundImage = `${
              APIENDPOINT(getCWPEnvironmentForURL(window.location.toString())).baseGallery
            }/content/gallery/ampmicrosites/facets/fadedfacetwhite.jpg`
            return (
              <a
                key={card.cardContent?.heading ?? card.cardId}
                href={card.cardContent?.url}
                className='u-linkClean Card-Border'
                data-analytics={card.cardContent?.dataAnalytics}
                onMouseDown={e => {
                  e.stopPropagation()
                  e.preventDefault()
                }}
              >
                <div
                  className={
                    'Card Card--withHeader u-flex u-flexCol u-padding0 u-paddingBottom20 u-posRelative u-bgColorWhite u-sizeFull'
                  }
                >
                  <>
                    <div className='Card-header Card-headerBackgroundImage Card--redesign card-image u-borderBottom0'>
                      <img
                        src={backgroundImage}
                        className='card-person-bg'
                        alt='faded facet background'
                      />
                      <div className='card-person-avatar'>
                        {cardImagePath && <img src={sanitizeHTML(cardImagePath)} alt='' />}
                      </div>
                    </div>
                    <div className='Card-body card-content u-paddingHoriz20'>
                      {card.cardContent?.superHeadline && (
                        <h5 className={`u-textColorLight u-textSizeMsrm1 u-textUppercase `}>
                          {card.cardContent?.superHeadline}
                        </h5>
                      )}
                      {card.cardContent?.heading && (
                        <div>
                          {card.cardContent.cardHeadingLevel === 'h4' ? (
                            <h4 className='card-heading u-paddingVert8 u-textColorNeutralGrey'>
                              <strong>{card.cardContent?.heading}</strong>
                            </h4>
                          ) : (
                            <h3 className='card-heading u-paddingVert8 u-textColorNeutralGrey'>
                              <strong>{card.cardContent?.heading}</strong>
                            </h3>
                          )}
                        </div>
                      )}
                      <div
                        className='card-description'
                        dangerouslySetInnerHTML={{
                          __html: sanitizeHTML(card.cardContent?.cardDescription ?? ''),
                        }}
                      />
                    </div>
                  </>
                </div>
              </a>
            )
          })}
        </div>
        {showLoadMore && (
          <div className='u-sizeConstrained u-flex u-flexJustifyCenter'>
            <button
              className='Button Button--secondary Button--secondary--action-blue Button--small'
              onClick={() => setShowLoadMore(false)}
            >
              Load more
            </button>
          </div>
        )}
      </div>
    </section>
  )
}
